<template>
  <div class="case-files shadow-sm">
    <div>
      <div
        class="row no-gutters list"
        v-for="file in caseFiles(value)"
        :key="file.id"
      >
        <div class="col item item-last">
          <a
            class="py-2 px-3 text-truncate"
            target="_blank"
            :href="`${staticUrl}/api/patient-cases/${value}/files/${file.id}/${file.name}?token=${authToken}`"
          >
            <file-icon></file-icon>
            {{ file.name }}
          </a>
        </div>
        <div class="col-auto item item-last item-action">
          <a class="py-2 px-3" @click.prevent="remove(file.id)">
            <span class="text-primary">
              <remove-icon></remove-icon>
            </span>
          </a>
        </div>
      </div>
    </div>
    <div class="row no-gutters list">
      <div class="col item item-bottom">
        <label class="file-select pointer">
          <div class="select-button py-3 px-3">
            <span v-if="file">
              <file-icon></file-icon>
              {{ $t("selectedFile") }}: {{ file.name }}
            </span>
            <span v-else>
              <file-icon></file-icon>
              {{ $t("selectFile") }}
            </span>
          </div>
          <input type="file" @change="handleFileChange" />
        </label>
      </div>
      <div class="col-auto item item-last item-bottom item-action">
        <button class="p-3 bg-primary text-white" type="button" @click="save">
          {{ $t("save") }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import FileIcon from '@/components/Icons/File'
import RemoveIcon from '@/components/Icons/Remove'
export default {
  components: {
    FileIcon,
    RemoveIcon
  },
  props: {
    value: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      file: null,
      files: []
    }
  },
  computed: {
    ...mapGetters({
      staticUrl: 'app/staticUrl',
      authToken: 'auth/token',
      caseFiles: 'pcase/files'
    })
  },
  methods: {
    ...mapMutations({
      setError: 'alert/setError',
      pushFile: 'pcase/pushFile',
      removeFile: 'pcase/removeFile'
    }),
    async remove (fileId) {
      try {
        await this.axios.delete(
          `/api/patient-cases/${this.value}/files/${fileId}`
        )
        this.removeFile({ id: this.value, fileId: fileId })
      } catch (err) {
        this.setError(err)
      }
    },
    handleFileChange (e) {
      this.file = e.target.files[0]
    },
    changed () {
      this.files = this.$refs.file.files
    },
    async save () {
      try {
        const formData = new FormData()
        // for (const file of this.files) {
        formData.append('file', this.file)
        // }
        const response = await this.axios.post(
          `/api/patient-cases/${this.value}/files`,
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        )
        this.pushFile({ id: this.value, file: response.data.data })
        this.file = null
        this.files = []
      } catch (err) {
        this.setError(err)
      }
    }
  }
}
</script>
<style lang="scss">
.case-files {
  .file-select {
    background-color: #eee !important;
    input[type="file"] {
      display: none;
    }
  }
}
</style>
<i18n>
{
  "ka": {
      "file": "ფაილი",
      "delete": "წაშლა",
      "save": "ატვირთვა",
      "selectedFile": "არჩეული ფაილი",
      "selectFile": "აირჩიე ფაილი"
  },
  "en": {
      "file": "File",
      "delete": "Delete",
      "save": "Upload",
      "selectedFile": "Seleted File",
      "selectFile": "Select File"
  }
}
</i18n>
